"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const formik_1 = require("formik");
const styles_1 = __importDefault(require("../../styles/styles"));
const button_1 = __importDefault(require("../button/button"));
const eventConstants_1 = require("../../constants/eventConstants");
const auditConstants_1 = require("./auditConstants");
const qualityAssuranceSlice_1 = require("../../features/qualityAssurance/qualityAssuranceSlice");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const auditUtils_1 = require("./auditUtils");
const constants_1 = require("../../constants/constants");
const auditFormFields_1 = __importDefault(require("./auditFormFields"));
const CallDetailRecordAuditForm = ({ callRecord, callDetailRecordAudit, }) => {
    const dispatch = useAppDispatch_1.default();
    const fields = auditConstants_1.evaluationFields.get(callRecord.call_type);
    if (fields === undefined)
        return null;
    const arrayFields = Array.from(fields.entries());
    const initialPayload = {
        ...auditUtils_1.generateInitialPayload(callDetailRecordAudit, fields),
        review_status: callRecord.review_status,
    };
    const onSubmit = (values) => {
        dispatch(qualityAssuranceSlice_1.auditCallDetailRecord({
            ...values,
            call_detail_record: callRecord.id,
            http_verb: callDetailRecordAudit ? constants_1.HTTP.PATCH : constants_1.HTTP.POST,
        }));
    };
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionColumn, styles_1.default.marginTen, styles_1.default.boxStyles] },
        react_1.default.createElement(formik_1.Formik, { initialValues: initialPayload, onSubmit: (values) => onSubmit(values), validate: auditUtils_1.validate, validateOnChange: false }, ({ handleSubmit, handleChange, values }) => (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginFive },
                react_1.default.createElement(auditFormFields_1.default, { values: values, handleChange: handleChange, fields: arrayFields })),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTopTen },
                react_1.default.createElement(button_1.default, { onPress: handleSubmit, text: callDetailRecordAudit ? 'Edit Audit' : 'Audit', fill: true, eventName: eventConstants_1.AUDIT_CALL_RECORD_DETAIL_BUTTON })))))));
};
exports.default = CallDetailRecordAuditForm;
